import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePracticeAuth } from "../context/PracticeAuthContext";

const PracticeProtectedRoute: React.FC = () => {
  const { isAuthenticated } = usePracticeAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/speaking-partner/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default PracticeProtectedRoute;
